import { useState, type FormEvent, type ReactNode } from 'react'

import * as authApi from '../api/auth.api.js'
import { ApiError } from '../api/client.js'
import { useAuth } from '../auth/AuthProvider.tsx'

function messageFor(error: unknown): string {
  if (!(error instanceof ApiError)) return 'Tidak dapat menghubungi server.'
  if (error.code === 'VALIDATION_ERROR') {
    // Detail per field dari server lebih tepat daripada pesan umum.
    return error.details?.map((d) => d.message).join('; ') ?? error.message
  }
  return 'Terjadi gangguan pada server. Coba beberapa saat lagi.'
}

export function AccountSection(): ReactNode {
  const { logout } = useAuth()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(event: FormEvent): Promise<void> {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await authApi.changePassword(current, next)
      // Seluruh sesi dicabut server; keluar dan minta masuk ulang.
      await logout()
    } catch (err) {
      setError(messageFor(err))
      setBusy(false)
    }
  }

  return (
    <section className="account">
      <h2>Ganti kata sandi</h2>
      <p className="hint">
        Setelah diganti, seluruh sesi — termasuk di perangkat lain — ditutup dan Anda diminta masuk
        kembali.
      </p>
      <form onSubmit={onSubmit} className="account-form">
        <label htmlFor="current">Kata sandi saat ini</label>
        <input
          id="current"
          type="password"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          disabled={busy}
        />
        <label htmlFor="next">Kata sandi baru (minimal 12 karakter)</label>
        <input
          id="next"
          type="password"
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          disabled={busy}
        />
        {error !== null && (
          <p role="alert" className="error">
            {error}
          </p>
        )}
        <button type="submit" disabled={busy || current === '' || next === ''}>
          {busy ? 'Mengganti…' : 'Ganti kata sandi'}
        </button>
      </form>
    </section>
  )
}
